export class Tile {
  constructor(
    public title: string,
    public icon: string,
    public description: string,
    public buttonLabel: string,
    public url?: string,
    public infographicsName?: string
  ) { }
}
